import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import {
    IRequestData,
    IHorizon,
    IFilterHorizons,
} from '../../../types';
import { AuthContext } from '../../../contexts/Auth/AuthContext';
import apiService from '../../../services/apiService';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

interface IHorizonProps {
    examId: string | undefined
    horizon: IHorizon
    horizonFilters: IFilterHorizons
    renewHorizon: (data: Array<IHorizon> | undefined) => void
}

export default function HorizonTextureItem(props: IHorizonProps) {
    const styles = useStyles();
    const auth = React.useContext(AuthContext);
    const [texture, setTexture] = useState<string>('0');
    const [textureUpdate, setTextureUpdate] = useState<boolean>(false);

    async function updateHorizon() {
        if (auth !== undefined && props.examId !== undefined && props.horizon !== undefined) {
            let request_data: IRequestData = {
                horizon_id: props.horizon.id,
                exam_id: parseInt(props.examId),
            };

            if (
                texture !== null &&
                texture !== '0' &&
                props.horizon.texture !== `${texture}`
            ) {
                request_data['texture'] = `${texture}`;
            }

            try {
                await apiService.put(
                    'exams/horizon',
                    request_data
                ).then((response) => {
                    if (response !== undefined && response.status === 200) {
                        props.renewHorizon(response.data.data as Array<IHorizon>);
                    }
                }).catch(() => {
                });
            } catch (e) {
            }
        }
    }

    useEffect(() => {
        if (textureUpdate === true) {
            updateHorizon();
            setTextureUpdate(false);
        }
        return () => setTextureUpdate(false);
        // eslint-disable-next-line
    }, [textureUpdate]);

    useEffect(() => {
        if (props.horizon !== undefined) {
            setTexture(((props.horizon.texture === undefined || props.horizon.texture === null) ? '0' : props.horizon.texture));
        }
        // eslint-disable-next-line
    }, [props]);

    return (
        <Grid 
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            key={`${props.horizon.id}${props.horizon.name}texture`}
            className={styles.view_horizon_texture}
        >
            <Grid item xs={12} className={styles.view_horizon_texture_title}>
                <Typography className={styles.text_horizon_texture}>
                    <strong>{props.horizon.name}</strong>
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_texture_content}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={12} className={styles.view_horizon_texture_subtitle}>
                        <TextField
                            className={styles.picker_select_type}
                            select
                            value={texture ? texture : "0"}
                            defaultValue={'0'}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setTexture(`${event.target.value}`);
                                setTextureUpdate(true);
                            }}
                        >
                            <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                            {props.horizonFilters.texture.map((element, key) => (
                                <MenuItem className={styles.picker_select_item} key={key} value={`${key + 1}`}>{`${element}`}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}